import angular from 'angular';
import { concat, flatten, map, range } from 'lodash';

let minutes = [ '00', '15', '30', '45'];

let visitingHours = range(8, 19);

let visitingTimes = visitingHours.map((hour) => {
  return minutes.map(min => `${hour % 12 || 12}:${min} ${hour < 12 ? 'AM' : 'PM'}`);
});

const VISITING_TIMES = concat(flatten(visitingTimes), '7:00 PM');

const ALL_TIMES = flatten(map(range(0, 23), (hour) => {
  return map(['00', '15', '30', '45'], (min) => {
    return `${hour % 12 || 12}:${min} ${hour < 12 ? 'AM' : 'PM'}`;
  });
}));

const AVAILABLE_TIMES = ALL_TIMES;

module.exports = angular.module('common.services.times', [])
.constant('AvailableTimes', AVAILABLE_TIMES)
.constant('AllTimes', ALL_TIMES)
.constant('VisitingTimes', VISITING_TIMES)
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/services/times.js
 **/